import React, { useEffect } from 'react';
import { m } from 'framer-motion';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Page not found — WebCodeCraft';
    let meta = document.querySelector('meta[name="robots"]');
    let created = false;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
      created = true;
    }
    const prevRobots = meta.getAttribute('content');
    meta.setAttribute('content', 'noindex, nofollow');
    return () => {
      document.title = prevTitle;
      if (created && meta.parentNode) meta.parentNode.removeChild(meta);
      else if (prevRobots != null) meta.setAttribute('content', prevRobots);
      else meta.removeAttribute('content');
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4">
      <m.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <m.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring' }}
          className="text-9xl font-bold gradient-text mb-4"
        >
          404
        </m.div>
        
        <h1 className="text-3xl font-bold text-white mb-4">Page Not Found</h1>
        
        <p className="text-gray-400 mb-8 max-w-md">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <m.button
              className="btn btn-primary flex items-center justify-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FiHome className="mr-2" />
              Go Home
            </m.button>
          </Link>
          
          <m.button
            onClick={() => window.history.back()}
            className="btn border-2 border-white text-white hover:bg-white hover:text-gray-900 flex items-center justify-center"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FiArrowLeft className="mr-2" />
            Go Back
          </m.button>
        </div>
      </m.div>
    </div>
  );
};

export default NotFoundPage;
